import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { Municipio } from '../models/municipio.model';

@Injectable({
  providedIn: 'root'
})
export class MunicipioService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all municipios by provinciaId
  list(provinciaId: any): Observable<Municipio[]> {
    const params = new HttpParams().set('provinciaId', provinciaId.toString()).set('page', '1').set('pageSize', '9999');
    return this.apiService.get<{ data: Municipio[] }>(`${this.path}/getAllMunicipio`, params).pipe(
      // debounceTime(500),
      map(response => response.data)
    );
  }

  // Get municipio by ID
  public show(id: string): Observable<Municipio> {
    return this.apiService.get<{ object: Municipio }>(`${this.path}/getMunicipioById/${id}`).pipe(
      map(response => response.object as Municipio)
    );
  }

  // Create new municipio
  public store(municipio: Municipio): Observable<Municipio> {
    return this.apiService
      .post<{ object: Municipio }>(`${this.path}/AddMunicipio`, municipio)
      .pipe(
        map((response) => response.object as Municipio)
      );
  }

  // Update existing municipio
  public update(municipio: Municipio, id: string): Observable<Municipio> {
    return this.apiService
      .put<{ object: Municipio }>(`${this.path}/UpdateMunicipio/${id}`, municipio)
      .pipe(
        map((response) => response.object as Municipio)
      );
  }

  // Delete existing municipio
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteMunicipioById/${id}`);
  }
}
